import React from 'react';
import { useLocation } from "react-router-dom";
import Tooltip from "components/tooltips/Tooltips";
import UseContext from "hooks/useContext";
import { ORANGE_COLORS } from "utils/colors";
import { IntercomIcon } from "assets/icons";

const IntercomDL = () => {
    const { sidebarExpanded } = UseContext();
    const location = useLocation();
    
    const handleClick = (e) => {
        e.preventDefault();
        window.open('https://app.intercom.com/', '_blank', 'noopener,noreferrer');
    };

    return (
        <li>
            <Tooltip
                text="Intercom"
                disabled={sidebarExpanded}
                placement="right"
            >
                <button
                    onClick={handleClick}
                    className="flex items-center h-[44px] rounded-lg border px-2 py-3 transition duration-150 border-white text-gray-700 bg-transparent hover:bg-gray-100 active:border-gray-200 w-full"
                >
                    <div id="Intercom" className="flex items-center w-full">
                        <span className='shrink-0'>
                            <IntercomIcon wh={24} color='#374151'/>
                        </span>
                        <span className={`ft-sm font-medium ml-4 ls:opacity-0 ls:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200`}>
                            Intercom
                        </span>
                    </div>
                </button>
            </Tooltip>
        </li>
    );
};

export default IntercomDL;

